module.exports = __webpack_public_path__ + "assets/img/pan2.297c8a7a.svg";